import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../interceptor/axiosInstance";
import { useNavigate } from "react-router-dom";
import "../../style/Common.css";

import "./Org.css";
import NotificationService from "../Utils/NotificationService"; // Import notification service

const AddAgent = () => {
    const navigate = useNavigate();

    // Formik for form handling and validation
    const [data, setData] = useState("");
    const [error, setError] = useState(null);

    const [isAddSuccessful, setIsAddSuccessful] = useState(false);

    const formik = useFormik({
        initialValues: {
            agentName: "",
            emailId: "",
        },
        validationSchema: Yup.object({
            agentName: Yup.string()
                .required("Agent Name is required")
                .max(50, "Must be 50 characters or less"),
            emailId: Yup.string()
                .email("Invalid email address")
                .required("Email is required"),
        }),

        onSubmit: async (payload, { resetForm }) => {
            console.log("Form Submitted:", payload);

            try {
                const response = await axiosInstance.post(`/agent/add`, payload);
                if (response.data && response.data.success) {
                setData(response.data); // Handle response data
                setError(null); // Clear any previous errors
                resetForm();
                setIsAddSuccessful(true);
                }else{
                    NotificationService.error(response.data.message || "Error creating agent. Please try again.");
                }
            } catch (err) {
                if(err.response.data.error === "ALREADY EXIST") {
                    NotificationService.error("An agent with the provided email address already exists. Please use a different email address.")
                }
                setError(err.message); // Handle error
                setData("");
            }

            // alert("Organization Signup Successful!");  
        },
    });

    if (isAddSuccessful) {
        navigate("/manage-agents");
        
    }

    const manageAgent = () => {
        navigate("/manage-agents");
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow">
                        <div className="tbl-title-color card-header text-white d-flex align-items-center position-relative">
                        <button className="btn-secondary-color back-button-padding btn position-absolute"
                            onClick = {manageAgent}
                        >Back
                        </button>
                        <h2 className="text-center flex-grow-1 mb-0 font-20">Add Agent</h2>
                        </div>
                        <div className="card-body">
                            <form onSubmit={formik.handleSubmit}>
                                {/* Organization Name */}
                                <div className="mb-3">
                                    <label htmlFor="agentName" className="form-label">
                                        Agent Name
                                    </label>
                                    <input
                                        id="agentName"
                                        name="agentName"
                                        type="text"
                                        className={`form-control ${formik.touched.agentName &&
                                                formik.errors.agentName
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                        value={formik.values.agentName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.agentName &&
                                        formik.errors.agentName && (
                                            <div className="invalid-feedback">
                                                {formik.errors.agentName}
                                            </div>
                                        )}
                                </div>

                                {/* Email */}
                                <div className="mb-3">
                                    <label htmlFor="emailId" className="form-label">
                                        Email
                                    </label>
                                    <input
                                        id="emailId"
                                        name="emailId"
                                        type="emailId"
                                        className={`form-control ${formik.touched.emailId && formik.errors.emailId
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                        value={formik.values.emailId}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.emailId && formik.errors.emailId && (
                                        <div className="invalid-feedback">
                                            {formik.errors.emailId}
                                        </div>
                                    )}
                                </div>


                                {/* Submit Button */}
                                <div>
                                    <button type="submit" className="btn btn-color w-100">
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddAgent;